<ion-header class="modal-header">
  <ion-toolbar>
    <div class="modal-title">
      <h3>
        {{ id ? 'Edit User Group' : 'Add User Group' }}
      </h3>
    </div>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 16px" class="constrained-content">
    <ion-label class="input-label"> Name </ion-label>
    <ion-input
      #nameInput
      placeholder="e.g. Tier 2 Support"
      [(ngModel)]="name"
      class="input-field"
      [disabled]="isDisabled"
    >
    </ion-input>

    <ion-label class="input-label"> Description </ion-label>
    <ion-textarea
      #descriptionInput
      placeholder="e.g. On-call team that handles escalated tickets"
      [(ngModel)]="description"
      class="input-field"
      [disabled]="isDisabled"
      rows="3"
      [autoGrow]="true"
    >
    </ion-textarea>

    <ion-label class="input-label"> Type </ion-label>
    <ion-select
      [(ngModel)]="isExternal"
      (ionChange)="isExternalDidChange()"
      [disabled]="isDisabled || id"
      interface="popover"
      slot="start"
      class="select-outline input-field"
    >
      <ion-select-option [value]="true"> External </ion-select-option>
      <ion-select-option [value]="false"> Internal </ion-select-option>
    </ion-select>

    <ion-label class="input-label"> Group membership rules </ion-label>
    <div class="input-field" style="padding: 0 4px">
      <div *ngIf="sourceType === 'system'">
        <ion-button class="fake-button" color="dark" fill="clear" [disabled]="true">
          <ion-icon name="flash-outline" class="padded-icon"></ion-icon>
          System-created group
        </ion-button>
      </div>
      <app-filter-button
        *ngIf="sourceType !== 'system'"
        [options]="filterOptions"
        (didChange)="filtersDidChange($event)"
        [selected]="filters"
        [disabled]="isDisabled"
      ></app-filter-button>
    </div>

    <div class="margin-bottom-10">
      <ion-label class="input-label"> Default Slack channel for notifications </ion-label>
      <app-channel-selector
        [channel]="notificationChannel"
        (channelDidChange)="onNotificationChannelChange($event)"
        [defaultInternalOnly]="true"
      ></app-channel-selector>
    </div>

    <ion-label class="input-label"> Members </ion-label>
    <div class="input-field" style="padding: 4px">
      <ngx-datatable
        class="material datatable-row-borders"
        [columnMode]="ColumnMode.force"
        [limit]="limit"
        [headerHeight]="0"
        [footerHeight]="50"
        [rowHeight]="50"
        [scrollbarH]="true"
        style="height: unset"
        paginated
        [dataSource]="usersDataSource"
        [loadingIndicator]="isLoadingUsers"
      >
        <ngx-datatable-column name="Name" [minWidth]="225">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <div style="display: flex; align-items: center">
              <ion-avatar class="user-photo">
                <app-avatar size="40" [name]="row.name" [image]="row.photo"></app-avatar>
              </ion-avatar>
              <span>
                {{ row.name }}
              </span>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Email" [minWidth]="225">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.email }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</ion-content>

<ion-footer class="footer flex-space-between" style="padding: 15px">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save
    <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
  </ion-button>
  <ion-button
    fill="clear"
    color="dark"
    (click)="delete()"
    [disabled]="isLoading"
    *ngIf="id && !isDisabled"
    ngxTippy
    data-tippy-content="Delete"
  >
    <ion-icon name="trash-outline"></ion-icon>
  </ion-button>
</ion-footer>
